// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3yk_l","label":"CategoryService_label__1kNkc","location":"CategoryService_location__2bm-i"};